import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { updateInstitute } from '../api/institutes.api';
import type { UpdateInstitutePayload } from '../types/institute.types';

export function useUpdateInstitute(id: number, onSuccess?: () => void) {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: (payload: UpdateInstitutePayload) => updateInstitute(id, payload),
    onSuccess: () => {
      void refreshRelatedData('institute');
      toast.success('Institute updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update institute');
    },
  });
}
